import { useAuth as useFlashAuth } from '../../context/authContext';
import { AppUser } from '../types';

interface AppAuth {
	user: AppUser | null;
	logout: () => void;
}

/**
 * Adapts flash's authContext to the shape ported new-ui components expect.
 * Maps flash's TUser (firstname/lastname) to the flat AppUser shape (first_name/last_name) and
 * exposes logout under the name the ported code uses.
 */
export function useAuth(): AppAuth {
	const flash = useFlashAuth();
	const data: any = flash?.userData;
	const user: AppUser | null = data
		? {
				email: data.email ?? '',
				first_name: data.firstname ?? '',
				last_name: data.lastname ?? '',
				is_verified: data.is_verified,
				role: data.role,
			}
		: null;

	return {
		user,
		logout: () => flash?.onLogout?.(),
	};
}
